import store from '../../store/'
import * as actions from '../../store/_actions'

const RequirementsModule = () => import('@pages/requirements/RequirementsModule.vue')
const Confirmation = () => import('@pages/requirements/NovaConfirmation.vue')
const RedirectToDashboard = () => import('@pages/requirements/NovaRedirectToDashboard.vue')

export default {
    path: '/requerimientos',
    component: RequirementsModule,
    name: 'requirementsModule',
    children: [
        {
            path: ':requirement/crear',
            component: () => import('@pages/requirements/RequirementsIndex.vue'),
            props: true,
            name: 'requirements',
        },
        {
            path: 'pqrs',
            component: () => import('@pages/requirements/NovaPetitionCreate.vue'),
            name: 'novaPqrsV2',
        },
        {
            path: 'nova-facility-bookings',
            component: () => import('@pages/requirements/NovaFacilityBookingCreate.vue'),
            name: 'novaFacilityBookingsV2',
        },

        {
            path: 'nova-facility-booking-list',
            component: () => import('@pages/requirements/NovaFacilityBookings.vue'),
            name: 'novaFacilityBookingListV2',
        },
        {
            path: 'nova-newsletters',
            component: () => import('@pages/communications/newsletters/NewsletterInternals.vue'),
            name: 'novaNewslettersV2',
        },
        {
            path: 'nova-account-status',
            component: () => import('@pages/requirements/NovaAccountStatement.vue'),
            name: 'novaAccountStatusV2',
        },
        {
            path: 'nova-documents',
            component: () => import('@pages/communications/archives/ArchiveIndex.vue'),
            name: 'novaDocumentsV2',
        },
        {
            path: 'nova-vecitienda',
            component: () => import('@pages/marketplace/Index.vue'),
            name: 'novaVecitiendaV2',
        },

        {
            path: 'confirmation',
            component: Confirmation,
            name: 'novaConfirmationV2',
            props: true,
        },
        {
            path: 'dashboard',
            component: RedirectToDashboard,
            name: 'novaRedirectDashboardV2',
            props: true,
        },
    ],

    async beforeEnter(to, from, next) {
        const payload = to.query.p
        const token = to.query.token
        if (!payload && !token) return next({ name: 'welcome' })
        await store.dispatch(actions.VERIFY_PERSON, { payload, token })
        next()
    },
}
